import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { notification } from "antd";

import api from "../../utils/api";

function useEmailInvite(companyId, opportunityId) {
  const { t } = useTranslation();
  const [status, setStatus] = useState("init"); // init | loading | resolved | rejected

  const inviteCandidate = useCallback(
    matchId => {
      setStatus("loading");
      return api.opportunity.candidates
        .inviteExternalCandidate(companyId, opportunityId, matchId)
        .then(() => {
          setStatus("resolved");
          notification.success({
            message: t("global:good"),
            description: t("toasts:opportunity.sendEmailExternalResolved")
          });
        })
        .catch(e => {
          setStatus("rejected");

          notification.error({
            message: t("global:error"),
            description: t("toasts:opportunity.sendEmailExternalRejected")
          });
          console.error("Hubo un error al enviar la invitación: " + e.message);
          // TODO revisar.
        });
    },
    [companyId, opportunityId, t]
  );

  return [inviteCandidate, status];
}

export default useEmailInvite;
